module.exports = __webpack_public_path__ + "static/media/6.Sprinkle Nozzels.ded1cb41.jpeg";